import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import AppStrings from '../../config/appstring'; 
import { useLocation } from 'react-router-dom';

const FeesPrint = ({ RefNo,onClose }) => {
  const location = useLocation();
  // const name = location.state?.name || 'No Name Passed';
  // const className = location.state?.className || 'I';
  // const AdmissionID = location.state?.AdmissionID || 'I16';

  const [feeDetails, setFeeDetails] = useState([]);
  const [totalAmt, setTotalAmt] = useState(0);
  const [Header1, setHeader1] = useState('');
  const [Header2, setHeader2] = useState('');
  const [STUDENTNAME, setStudentName] = useState('');
  const [VoucherNo, setVoucherNo] = useState('');
  const [TYPE, setTYPE] = useState('');
  const [EntDate, setEntDate] = useState('');
  const [className, setclassName] = useState('');
  const [AdmissionID, setAdmissionID] = useState('');
  const [PICKUPPLACE, setPICKUPPLACE] = useState('');
  const academicFees = feeDetails.filter(fee => fee.FEESTYPE === 'ACADEMIC');
const transportFees = feeDetails.filter(fee => fee.FEESTYPE === 'TRANSPORT');
const [Total, setTotal] = useState('');
const [Paid, setPaid] = useState('');
const [BALANCE, setBALANCE] = useState('');
const [SchoolPay, setSchoolPay] = useState('');
  const [BusPay, setBusPay] = useState('');
  const [UserName, setUserName] = useState('');
  //const [className, setclassName] = useState('');

  const tableRef = useRef();

  // Fetch fee details
  useEffect(() => {
    const fetchFeeDetails = async () => {
      // Replace this with dynamic URL if needed
      const url = AppStrings.BillPrint+`?REFNO=${RefNo || '2425SCISM2512'}`;
      try {
        const response = await axios.get(url);
        const data = response.data.data?.[0];

        const result = data?.result || data?.LIST || [];
        setTotalAmt(data?.TOTAL || 0);
        setHeader1(data?.COMPANYDETAIL?.[0]?.DATA1 || '');
        setHeader2(data?.COMPANYDETAIL?.[0]?.DATA2 || '');
        setStudentName(data?.STUDENTNAME || 0);
        setVoucherNo(data?.SCHOOL_VOUNO || data?.BUS_VOUNO);
  
        setTYPE(data?.TYPE || 0);
         setEntDate(data?.SCHOOL_DATE || data?.BUS_DATE);
         setclassName(data?.CLASS || 0);
         setAdmissionID(data?.STUDENTID || 0);
         setPICKUPPLACE(data?.PICKUPPLACE || 0);
          setTotal(data?.TOTAL || 0);
         setPaid(data?.PAID || 0);
         setBALANCE(data?.BALANCE || 0);
         setSchoolPay(data?.SCHOOL_FEESAPPLIED || 0);
         setBusPay(data?.BUS_FEESAPPLIED || 0);
setUserName(data?.USERNAME || 0);
        if (Array.isArray(result)) {
          const withEditable = result.map(item => ({ ...item, current: '', discount: '' }));
          setFeeDetails(withEditable);
        } else {
          alert("No fee records found.");
          setFeeDetails([]);
        }
      } catch (error) {
        console.error("Error fetching fee details:", error);
        alert("Failed to fetch fee details.");
      }
    };

    fetchFeeDetails();
  }, [RefNo]);


//   useEffect(() => {
//   if (feeDetails.length > 0) {
//     setTimeout(() => handlePrint(), 1000); // Wait 1 sec to load
//   }
// }, [feeDetails]);

 const currentDate = new Date().toLocaleDateString();
  // Print functionality
  const handlePrint = () => {
    const printContents = tableRef.current.innerHTML;
    const printWindow = window.open('', '_blank', 'width=900,height=650');

   

    printWindow.document.write(`
      <html>
        <head>
          <style>
            body {
              font-family: Verdana, sans-serif;
              padding: 20px;
            }
            .print-container {
              border: 2px solid #000;
              padding: 20px;
              margin: auto;
            }
            .header-row {
              display: flex;
              justify-content: space-between;
              margin-bottom: 20px;
            }
            .header-box {
              width: 25%;
              height: 100px;
              padding: 10px;
              box-sizing: border-box;
              border: 1px solid #ccc;
              background-color: #f9f9f9;
            }
            .Logo {
              width: 18%;
              height: 100px;
            }
            .Address {
              width: 82%;
            }
            table {
              width: 100%;
              border-collapse: collapse;
              margin-top: 0px;
            }
            th, td {
              border: 1px solid #ccc;
              padding: 8px;
              text-align: left;
            }
            th {
              background-color: #f2f2f2;
            }
            h2 {
              margin-top: 0;
            }
            .footer {
              margin-top: 20px;
              font-size: 12px;
              color: #888;
            }
          </style>
        </head>
        <body onload="window.print(); window.close();">
          <div class="print-container">
           

            <div>${printContents}</div>

           
          </div>
        </body>
      </html>
    `);
    printWindow.document.close();
  };

  const headerCellStyle = {
    padding: '2px',
    backgroundColor: '#f9f9f9',
    border: '1px solid #ccc',
    fontSize:'15px',
     width: '60%'
  };

  const cellStyle = {
    padding: '2px',
    border: '1px solid #ccc',
    fontSize:'15px'
  };
const headerrow={
   display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '10px',
}
const headerBoxStyle = {
  width: '25%',
  height: '100px',
  padding: '10px',
  boxSizing: 'border-box',
  border: '1px solid #ccc',
  backgroundColor: '#f9f9f9',
};

const StudentheaderBoxStyle = {
  width: '25%',
  height: '45px',
  padding: '2px',
  boxSizing: 'border-box',
  border: '1px solid #ccc',
  backgroundColor: '#f9f9f9',
  fontSize:'13px'
};



const CompNameHeader = {
  fontSize:'20px',
  fontWeight:'bold'
};

const logoStyle = {
  ...headerBoxStyle,
  width: '18%',
  height: '100px',
};

const addressStyle = {
  ...headerBoxStyle,
  width: '82%',
};
  return (
    <div>
      <div ref={tableRef}>
          <div style={headerrow}>
              <div style={logoStyle}>
                 <img
     src={
      TYPE === 'CBSE'
        ? 'https://schoolmanagement.agnisofterp.com/image/cbse_logo.jpeg'
        : 'https://schoolmanagement.agnisofterp.com/image/school_logo.png'
    }
    alt="School Logo"
    style={{ width: '100%', height: '100%', objectFit: 'contain' }}
  />
              </div>
              <div style={addressStyle}>
                <div style={CompNameHeader}>{Header1}</div>
                <div>{Header2}</div>
              </div>
            </div>
             <div style={headerrow}>
              <div style={StudentheaderBoxStyle}> <span style={{ fontWeight: 'bold' }}>Name :</span><br></br> {STUDENTNAME}</div>
              <div style={StudentheaderBoxStyle}> <span style={{ fontWeight: 'bold' }}>Class :</span><br></br>{className}</div>
              <div style={StudentheaderBoxStyle}> <span style={{ fontWeight: 'bold' }}>Admission Id :</span><br></br>{AdmissionID}</div>
              <div style={StudentheaderBoxStyle}> <span style={{ fontWeight: 'bold' }}>Vou No -Date :</span><br></br> {VoucherNo} - {EntDate}</div>
            </div>
        
        {academicFees.length > 0 ? (
          <>
          <div style={{fontWeight:'bold'}}>Academic Fees</div>
        
          <table style={{ width: '100%', marginTop: '10px', borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                <th style={headerCellStyle}>Fee Type</th>
                <th style={headerCellStyle}>Paid</th>
              </tr>
            </thead>
            <tbody>
              {academicFees.map((fee, idx) => (
                <tr key={idx}>
                  <td style={cellStyle}>{fee.TYPE}</td>
                  <td style={cellStyle}>{fee.PAYMENT}</td>
                </tr>
              ))}
            </tbody>
          </table>
            </>
        ) : (
          <p></p>
        )}
        
        {transportFees.length > 0 ? (
          <>
          <div style={{fontWeight:'bold', marginTop: '10px'}}>Transport Fees</div>
          <table style={{ width: '100%', marginTop: '10px', borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                <th style={headerCellStyle}>Fee Type</th>
                <th style={headerCellStyle}>Paid</th>
              </tr>
            </thead>
            <tbody>
              {
              transportFees.map((fee, idx) => (
                // console.log('Fee Item:', fee),
                <tr key={idx}>
                  <td style={cellStyle}>{fee.TYPE+' '+fee.PLACE}</td>
                  <td style={cellStyle}>{fee.PAYMENT}</td>
                </tr>
              ))}
            </tbody>
          </table>
          </>
        ) : (
          <p></p>
        )}
        <br></br>
 <div style={headerrow}>
              <div style={StudentheaderBoxStyle}> <span style={{ fontWeight: 'bold' }}>Total :</span><br></br> {parseFloat(Total || 0).toFixed(2)}</div>
              <div style={StudentheaderBoxStyle}> <span style={{ fontWeight: 'bold' }}>As Pay :</span><br></br> {(parseFloat(SchoolPay) + parseFloat(BusPay)).toFixed(2)}</div>
              <div style={StudentheaderBoxStyle}> <span style={{ fontWeight: 'bold' }}>Paid :</span><br></br>{parseFloat(Paid || 0).toFixed(2)}</div>
              <div style={StudentheaderBoxStyle}> <span style={{ fontWeight: 'bold' }}>Balance :</span><br></br> {parseFloat(BALANCE || 0).toFixed(2)}</div>
            </div>
           
              <div style={{fontSize:'15px'}}> <span style={{ fontWeight: 'bold' }}>Fees Collected By </span><br></br>  {UserName && UserName !== '0' ? UserName : ''}</div>
          

      </div>

      <div style={{ textAlign: 'center', marginTop: '20px' }}>
        <button
          onClick={handlePrint}
          style={{
            padding: '10px 20px',
            backgroundColor: '#007bff',
            color: '#fff',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
          }}
        >
          🖨️ Print
        </button>
        <button onClick={onClose} style={{  padding: '10px 20px',
            backgroundColor: '#007bff',
            color: '#fff',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer', }}>Close</button>
      </div>
    </div>
  );
};

export default FeesPrint;
